/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Footer "Cookie Preferences" link: intercept navigation to #cookie-preferences
// and open the cookie consent tool's preference center instead of scrolling.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a[href$="#cookie-preferences"]');
  if (!trigger) return;

  event.preventDefault();

  if (typeof window.showPreferences === 'function') {
    window.showPreferences();
  } else {
    console.error('showPreferences() is not defined');
  }
});
